import { GetUploadUrlRequest, GetUploadUrlResponse } from '@eigtech/documents-types'
import { contextualGet, queryOptions } from '@eigtech/ui-shared-api'
import { useUploadFile, useUploadMultipleFiles } from '@eigtech/ui-shared-files'
import { documentsBasePath, documentsQueryKeys } from './constants'

const getUploadDocumentUrl = ({ entityId, cohort }: GetUploadUrlRequest) =>
  contextualGet<GetUploadUrlResponse>(`${documentsBasePath}/${cohort}/${entityId}/upload-url`)

const uploadDocumentQueryOptions = (props: GetUploadUrlRequest) =>
  queryOptions({
    queryKey: documentsQueryKeys.uploadUrl(props),
    queryFn: () => getUploadDocumentUrl(props),
  })

export function useUploadDocument(props: GetUploadUrlRequest) {
  return useUploadFile(uploadDocumentQueryOptions(props), {
    defaultMeta: { notes: '', description: '', title: '' },
  })
}

export function useUploadMultipleDocuments(props: GetUploadUrlRequest) {
  return useUploadMultipleFiles(uploadDocumentQueryOptions(props), {
    defaultMeta: { notes: '', description: '', title: '' },
  })
}
